export default function disposeCurrentUser(currentUserVar) {
    return function () {
        currentUserVar(null);
    };
}
